export default {
  // =========================================================================
  // SECTOR IMPORTANCE
  // =========================================================================
  sector_importance: {
    type: "categorical",
    label: "Sector importance",
    category: "business",
    fulltext: "When thinking about the future of the UK economy, which sectors do you think are most important? Please select up to three.",
    client: "all",
    keys: [
      "ind:importance:big_tech:cat",
      "ind:importance:energy:cat",
      "ind:importance:water:cat",
      "ind:importance:oil_gas:cat",
      "ind:importance:healthcare:cat",
      "ind:importance:supermarkets:cat",
      "ind:importance:construction:cat",
      "ind:importance:farming:cat",
      "ind:importance:gambling:cat",
      "ind:importance:banks:cat",
      "ind:importance:online:cat",
      "ind:importance:propertydev:cat",
      "ind:importance:hospitality:cat",
      "ind:importance:defence:cat",
      "ind:importance:other:cat",
      "ind:importance:dk:cat",
    ],
    labels: {
      "ind:importance:big_tech:cat":     "Technology and social media companies",
      "ind:importance:energy:cat":       "Energy companies (gas, electricity)",
      "ind:importance:oil_gas:cat":       "Oil & Gas",
      "ind:importance:water:cat":        "Water and utility companies",
      "ind:importance:healthcare:cat":   "Healthcare, life sciences & pharma",
      "ind:importance:supermarkets:cat": "Retailers and supermarkets",
      "ind:importance:construction:cat": "Construction, property & housebuilding",
      "ind:importance:farming:cat":      "Farming and food production",
      "ind:importance:gambling:cat":     "Gambling companies and bookmakers",
      "ind:importance:banks:cat":        "Banks, insurance & financial services",
      "ind:importance:online:cat":       "Online retailers",
      "ind:importance:propertydev:cat":  "Property developers & housebuilders",
      "ind:importance:hospitality:cat":  "Hospitality (restaurants, hotels)",
      "ind:importance:defence:cat":      "Defence contractors",
      "ind:importance:other:cat":        "Other",
      "ind:importance:dk:cat":           "Don't know",
    },
    colors: {
      "ind:importance:big_tech:cat":     "#7B1FA2",
      "ind:importance:energy:cat":       "#F57C00",
      "ind:importance:water:cat":        "#0097A7",
      "ind:importance:healthcare:cat":   "#D81B60",
      "ind:importance:supermarkets:cat": "#388E3C",
      "ind:importance:construction:cat": "#F9A825",
      "ind:importance:farming:cat":      "#33691E",
      "ind:importance:gambling:cat":     "#C62828",
      "ind:importance:banks:cat":        "#1565C0",
      "ind:importance:online:cat":       "#00897B",
      "ind:importance:propertydev:cat":  "#8D6E63",
      "ind:importance:hospitality:cat":  "#FB8C00",
      "ind:importance:defence:cat":      "#37474F",
      "ind:importance:other:cat":        "#777777",
      "ind:importance:oil_gas:cat": "#795548",
      "ind:importance:dk:cat":           "#BDBDBD",
    },
    schema: "tracking",
    waves: [3,4,5]
  },

  // =========================================================================
  // SECTOR TRUST — GRID (parent group, references sub-variables below)
  // =========================================================================
  trust: {
    type: "likert_grid",
    label: "Sector trust",
    netLabel: "trust in the sector",
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public?",
    client: "all",
    category: "business",
    subVariables: [
      "trust_banks",
      "trust_big_tech",
      "trust_oil",
      "trust_online",
      "trust_propertydev",
      "trust_supermarkets",
      "trust_hospitality",
      "trust_construction",
      "trust_defence",
      "trust_gambling",
      "trust_energy",
      "trust_water",
      "trust_healthcare",
      "trust_farming",
    ],
    subLabels: {
      "trust_banks":      "Banks",
      "trust_big_tech":      "Big tech",
      "trust_oil":           "Oil & gas",
      "trust_online":        "Online retailers",
      "trust_propertydev":   "Property developers",
      "trust_supermarkets":  "Retailers",
      "trust_hospitality":   "Hospitality",
      "trust_construction":  "Construction",
      "trust_defence":       "Defence",
      "trust_gambling":      "Gambling",
      "trust_energy":        "Energy",
      "trust_water":         "Water & utilities",
      "trust_healthcare":    "Healthcare & pharma",
      "trust_farming":       "Farming",
    },
    subColors: {
      "trust_banks":      "#1565C0",
      "trust_big_tech":      "#7B1FA2",
      "trust_oil":           "#795548",
      "trust_online":        "#00897B",
      "trust_propertydev":   "#8D6E63",
      "trust_supermarkets":  "#388E3C",
      "trust_hospitality":   "#FB8C00",
      "trust_construction":  "#F9A825",
      "trust_defence":       "#37474F",
      "trust_gambling":      "#C62828",
      "trust_energy":        "#F57C00",
      "trust_water":         "#0097A7",
      "trust_healthcare":    "#D81B60",
      "trust_farming":       "#33691E",
    },
    // Flat union of all sub-variable keys — used by fetchMetrics to request all trust data
    keys: [
      "ind:trust_banks:trust_completely:cat", "ind:trust_banks:tend_trust:cat", "ind:trust_banks:neither:cat", "ind:trust_banks:tend_distrust:cat", "ind:trust_banks:no_trust:cat", "ind:trust_banks:dk:cat",
       "ind:trust_big_tech:trust_completely:cat", "ind:trust_big_tech:tend_trust:cat", "ind:trust_big_tech:neither:cat", "ind:trust_big_tech:tend_distrust:cat", "ind:trust_big_tech:no_trust:cat", "ind:trust_big_tech:dk:cat",
      "ind:trust_oil:trust_completely:cat", "ind:trust_oil:tend_trust:cat", "ind:trust_oil:neither:cat", "ind:trust_oil:tend_distrust:cat", "ind:trust_oil:no_trust:cat", "ind:trust_oil:dk:cat",
      "ind:trust_online:trust_completely:cat", "ind:trust_online:tend_trust:cat", "ind:trust_online:neither:cat", "ind:trust_online:tend_distrust:cat", "ind:trust_online:no_trust:cat", "ind:trust_online:dk:cat",
      "ind:trust_propertydev:trust_completely:cat", "ind:trust_propertydev:tend_trust:cat", "ind:trust_propertydev:neither:cat", "ind:trust_propertydev:tend_distrust:cat", "ind:trust_propertydev:no_trust:cat", "ind:trust_propertydev:dk:cat",
      "ind:trust_supermarkets:trust_completely:cat", "ind:trust_supermarkets:tend_trust:cat", "ind:trust_supermarkets:neither:cat", "ind:trust_supermarkets:tend_distrust:cat", "ind:trust_supermarkets:no_trust:cat", "ind:trust_supermarkets:dk:cat",
      "ind:trust_hospitality:trust_completely:cat", "ind:trust_hospitality:tend_trust:cat", "ind:trust_hospitality:neither:cat", "ind:trust_hospitality:tend_distrust:cat", "ind:trust_hospitality:no_trust:cat", "ind:trust_hospitality:dk:cat",
      "ind:trust_construction:trust_completely:cat", "ind:trust_construction:tend_trust:cat", "ind:trust_construction:neither:cat", "ind:trust_construction:tend_distrust:cat", "ind:trust_construction:no_trust:cat", "ind:trust_construction:dk:cat",
      "ind:trust_defence:trust_completely:cat", "ind:trust_defence:tend_trust:cat", "ind:trust_defence:neither:cat", "ind:trust_defence:tend_distrust:cat", "ind:trust_defence:no_trust:cat", "ind:trust_defence:dk:cat",
      "ind:trust_gambling:trust_completely:cat", "ind:trust_gambling:tend_trust:cat", "ind:trust_gambling:neither:cat", "ind:trust_gambling:tend_distrust:cat", "ind:trust_gambling:no_trust:cat", "ind:trust_gambling:dk:cat",
      "ind:trust_energy:trust_completely:cat", "ind:trust_energy:tend_trust:cat", "ind:trust_energy:neither:cat", "ind:trust_energy:tend_distrust:cat", "ind:trust_energy:no_trust:cat", "ind:trust_energy:dk:cat",
      "ind:trust_water:trust_completely:cat", "ind:trust_water:tend_trust:cat", "ind:trust_water:neither:cat", "ind:trust_water:tend_distrust:cat", "ind:trust_water:no_trust:cat", "ind:trust_water:dk:cat",
      "ind:trust_healthcare:trust_completely:cat", "ind:trust_healthcare:tend_trust:cat", "ind:trust_healthcare:neither:cat", "ind:trust_healthcare:tend_distrust:cat", "ind:trust_healthcare:no_trust:cat", "ind:trust_healthcare:dk:cat",
      "ind:trust_farming:trust_completely:cat", "ind:trust_farming:tend_trust:cat", "ind:trust_farming:neither:cat", "ind:trust_farming:tend_distrust:cat", "ind:trust_farming:no_trust:cat", "ind:trust_farming:dk:cat",
    ],
    labels: {},
    schema: "tracking",
    waves: [3,4,5],
  },

  // =========================================================================
  // SECTOR TRUST (likert grids — one group per sector, hidden from main dropdown)
  // =========================================================================
  trust_banks: {
    type: "likert",
    label: "Trust: Banks & financial services",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Banks, insurance and financial services",
    client: "all",
    keys: [
      "ind:trust_banks:trust_completely:cat",
      "ind:trust_banks:tend_trust:cat",
      "ind:trust_banks:neither:cat",
      "ind:trust_banks:tend_distrust:cat",
      "ind:trust_banks:no_trust:cat",
      "ind:trust_banks:dk:cat",
    ],
    labels: {
      "ind:trust_banks:trust_completely:cat": "Trust completely",
      "ind:trust_banks:tend_trust:cat":       "Tend to trust",
      "ind:trust_banks:neither:cat":          "Neither trust nor distrust",
      "ind:trust_banks:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_banks:no_trust:cat":         "Do not trust at all",
      "ind:trust_banks:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_banks:trust_completely:cat", "ind:trust_banks:tend_trust:cat"],
      neu: "ind:trust_banks:neither:cat",
      neg: ["ind:trust_banks:tend_distrust:cat", "ind:trust_banks:no_trust:cat"],
      dk:  "ind:trust_banks:dk:cat",
    },
    schema: "tracking",
    waves: [3,5]
  },

  trust_nat_resources: {
    type: "likert",
    label: "Trust: Natural resources",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Natural resources (e.g., mining, extraction of oil and gas)",
    client: "all",
    keys: [
      "ind:trust_nat_resources:trust_completely:cat",
      "ind:trust_nat_resources:tend_trust:cat",
      "ind:trust_nat_resources:neither:cat",
      "ind:trust_nat_resources:tend_distrust:cat",
      "ind:trust_nat_resources:no_trust:cat",
      "ind:trust_nat_resources:dk:cat",
    ],
    labels: {
      "ind:trust_nat_resources:trust_completely:cat": "Trust completely",
      "ind:trust_nat_resources:tend_trust:cat":       "Tend to trust",
      "ind:trust_nat_resources:neither:cat":          "Neither trust nor distrust",
      "ind:trust_nat_resources:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_nat_resources:no_trust:cat":         "Do not trust at all",
      "ind:trust_nat_resources:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_nat_resources:trust_completely:cat", "ind:trust_nat_resources:tend_trust:cat"],
      neu: "ind:trust_nat_resources:neither:cat",
      neg: ["ind:trust_nat_resources:tend_distrust:cat", "ind:trust_nat_resources:no_trust:cat"],
      dk:  "ind:trust_nat_resources:dk:cat",
    },
    schema: "tracking",
    waves: [3]
  },

  trust_energy: {
    type: "likert",
    label: "Trust: Energy companies",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Energy companies (e.g., gas, electricity)",
    client: "all",
    keys: [
      "ind:trust_energy:trust_completely:cat",
      "ind:trust_energy:tend_trust:cat",
      "ind:trust_energy:neither:cat",
      "ind:trust_energy:tend_distrust:cat",
      "ind:trust_energy:no_trust:cat",
      "ind:trust_energy:dk:cat",
    ],
    labels: {
      "ind:trust_energy:trust_completely:cat": "Trust completely",
      "ind:trust_energy:tend_trust:cat":       "Tend to trust",
      "ind:trust_energy:neither:cat":          "Neither trust nor distrust",
      "ind:trust_energy:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_energy:no_trust:cat":         "Do not trust at all",
      "ind:trust_energy:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_energy:trust_completely:cat", "ind:trust_energy:tend_trust:cat"],
      neu: "ind:trust_energy:neither:cat",
      neg: ["ind:trust_energy:tend_distrust:cat", "ind:trust_energy:no_trust:cat"],
      dk:  "ind:trust_energy:dk:cat",
    },
    schema: "tracking",
    waves: [3,4,5],
    // providerFilter: {
    //   providers: [
    //     { key: "octopus", label: "Octopus", variable: "trust_big_tech" },
    //     { key: "britishgas", label: "British Gas", variable: "trust_healthcare" },
    //     { key: "edf", label: "EDF", variable: "trust_banks" },
    //   ],
    //   visibleTo: ["octopus", "stack-data-strategy"],
    // },
  },

  // // Client-facing energy trust question with provider filter — visible in Octopus client tab
  // energy_trust_by_provider: {
  //   type: "likert",
  //   label: "Trust: Energy companies (by provider)",
  //   category: "business",
  //   fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Energy companies (e.g., gas, electricity). Filter by energy provider to see how trust varies among different customer bases.",
  //   client: ["octopus", "stack-data-strategy"],
  //   keys: [
  //     "ind:trust_energy:trust_completely:cat",
  //     "ind:trust_energy:tend_trust:cat",
  //     "ind:trust_energy:neither:cat",
  //     "ind:trust_energy:tend_distrust:cat",
  //     "ind:trust_energy:no_trust:cat",
  //     "ind:trust_energy:dk:cat",
  //   ],
  //   labels: {
  //     "ind:trust_energy:trust_completely:cat": "Trust completely",
  //     "ind:trust_energy:tend_trust:cat":       "Tend to trust",
  //     "ind:trust_energy:neither:cat":          "Neither trust nor distrust",
  //     "ind:trust_energy:tend_distrust:cat":    "Tend to distrust",
  //     "ind:trust_energy:no_trust:cat":         "Do not trust at all",
  //     "ind:trust_energy:dk:cat":               "Don't know",
  //   },
  //   polarity: {
  //     pos: ["ind:trust_energy:trust_completely:cat", "ind:trust_energy:tend_trust:cat"],
  //     neu: "ind:trust_energy:neither:cat",
  //     neg: ["ind:trust_energy:tend_distrust:cat", "ind:trust_energy:no_trust:cat"],
  //     dk:  "ind:trust_energy:dk:cat",
  //   },
  //   schema: "tracking",
  //   waves: [3,4],
  //   providerFilter: {
  //     providers: [
  //       { key: "octopus", label: "Octopus", variable: "trust_big_tech" },
  //       { key: "britishgas", label: "British Gas", variable: "trust_healthcare" },
  //       { key: "edf", label: "EDF", variable: "trust_banks" },
  //     ],
  //     visibleTo: ["octopus", "stack-data-strategy"],
  //   },
  // },

  trust_water: {
    type: "likert",
    label: "Trust: Water & utilities",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Water and utility companies",
    client: "all",
    keys: [
      "ind:trust_water:trust_completely:cat",
      "ind:trust_water:tend_trust:cat",
      "ind:trust_water:neither:cat",
      "ind:trust_water:tend_distrust:cat",
      "ind:trust_water:no_trust:cat",
      "ind:trust_water:dk:cat",
    ],
    labels: {
      "ind:trust_water:trust_completely:cat": "Trust completely",
      "ind:trust_water:tend_trust:cat":       "Tend to trust",
      "ind:trust_water:neither:cat":          "Neither trust nor distrust",
      "ind:trust_water:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_water:no_trust:cat":         "Do not trust at all",
      "ind:trust_water:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_water:trust_completely:cat", "ind:trust_water:tend_trust:cat"],
      neu: "ind:trust_water:neither:cat",
      neg: ["ind:trust_water:tend_distrust:cat", "ind:trust_water:no_trust:cat"],
      dk:  "ind:trust_water:dk:cat",
    },
    schema: "tracking",
    waves: [3,4,5]
  },

  trust_public_transport: {
    type: "likert",
    label: "Trust: Rail & public transport",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Rail and public transport",
    client: "all",
    keys: [
      "ind:trust_public_transport:trust_completely:cat",
      "ind:trust_public_transport:tend_trust:cat",
      "ind:trust_public_transport:neither:cat",
      "ind:trust_public_transport:tend_distrust:cat",
      "ind:trust_public_transport:no_trust:cat",
      "ind:trust_public_transport:dk:cat",
    ],
    labels: {
      "ind:trust_public_transport:trust_completely:cat": "Trust completely",
      "ind:trust_public_transport:tend_trust:cat":       "Tend to trust",
      "ind:trust_public_transport:neither:cat":          "Neither trust nor distrust",
      "ind:trust_public_transport:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_public_transport:no_trust:cat":         "Do not trust at all",
      "ind:trust_public_transport:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_public_transport:trust_completely:cat", "ind:trust_public_transport:tend_trust:cat"],
      neu: "ind:trust_public_transport:neither:cat",
      neg: ["ind:trust_public_transport:tend_distrust:cat", "ind:trust_public_transport:no_trust:cat"],
      dk:  "ind:trust_public_transport:dk:cat",
    },
    schema: "tracking",
    waves: [3]
  },

  trust_big_tech: {
    type: "likert",
    label: "Trust: Technology & social media",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Technology and social media companies",
    client: "all",
    keys: [
      "ind:trust_big_tech:trust_completely:cat",
      "ind:trust_big_tech:tend_trust:cat",
      "ind:trust_big_tech:neither:cat",
      "ind:trust_big_tech:tend_distrust:cat",
      "ind:trust_big_tech:no_trust:cat",
      "ind:trust_big_tech:dk:cat",
    ],
    labels: {
      "ind:trust_big_tech:trust_completely:cat": "Trust completely",
      "ind:trust_big_tech:tend_trust:cat":       "Tend to trust",
      "ind:trust_big_tech:neither:cat":          "Neither trust nor distrust",
      "ind:trust_big_tech:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_big_tech:no_trust:cat":         "Do not trust at all",
      "ind:trust_big_tech:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_big_tech:trust_completely:cat", "ind:trust_big_tech:tend_trust:cat"],
      neu: "ind:trust_big_tech:neither:cat",
      neg: ["ind:trust_big_tech:tend_distrust:cat", "ind:trust_big_tech:no_trust:cat"],
      dk:  "ind:trust_big_tech:dk:cat",
    },
    schema: "tracking",
    waves: [3,4,5]
  },

  trust_healthcare: {
    type: "likert",
    label: "Trust: Healthcare & pharma",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Healthcare, life sciences and pharmaceutical companies",
    client: "all",
    keys: [
      "ind:trust_healthcare:trust_completely:cat",
      "ind:trust_healthcare:tend_trust:cat",
      "ind:trust_healthcare:neither:cat",
      "ind:trust_healthcare:tend_distrust:cat",
      "ind:trust_healthcare:no_trust:cat",
      "ind:trust_healthcare:dk:cat",
    ],
    labels: {
      "ind:trust_healthcare:trust_completely:cat": "Trust completely",
      "ind:trust_healthcare:tend_trust:cat":       "Tend to trust",
      "ind:trust_healthcare:neither:cat":          "Neither trust nor distrust",
      "ind:trust_healthcare:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_healthcare:no_trust:cat":         "Do not trust at all",
      "ind:trust_healthcare:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_healthcare:trust_completely:cat", "ind:trust_healthcare:tend_trust:cat"],
      neu: "ind:trust_healthcare:neither:cat",
      neg: ["ind:trust_healthcare:tend_distrust:cat", "ind:trust_healthcare:no_trust:cat"],
      dk:  "ind:trust_healthcare:dk:cat",
    },
    schema: "tracking",
    waves: [3,4,5]
  },

  trust_supermarkets: {
    type: "likert",
    label: "Trust: Retailers & supermarkets",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Retailers and supermarkets",
    client: "all",
    keys: [
      "ind:trust_supermarkets:trust_completely:cat",
      "ind:trust_supermarkets:tend_trust:cat",
      "ind:trust_supermarkets:neither:cat",
      "ind:trust_supermarkets:tend_distrust:cat",
      "ind:trust_supermarkets:no_trust:cat",
      "ind:trust_supermarkets:dk:cat",
    ],
    labels: {
      "ind:trust_supermarkets:trust_completely:cat": "Trust completely",
      "ind:trust_supermarkets:tend_trust:cat":       "Tend to trust",
      "ind:trust_supermarkets:neither:cat":          "Neither trust nor distrust",
      "ind:trust_supermarkets:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_supermarkets:no_trust:cat":         "Do not trust at all",
      "ind:trust_supermarkets:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_supermarkets:trust_completely:cat", "ind:trust_supermarkets:tend_trust:cat"],
      neu: "ind:trust_supermarkets:neither:cat",
      neg: ["ind:trust_supermarkets:tend_distrust:cat", "ind:trust_supermarkets:no_trust:cat"],
      dk:  "ind:trust_supermarkets:dk:cat",
    },
    schema: "tracking",
    waves: [3,4,5]
  },

  trust_construction: {
    type: "likert",
    label: "Trust: Construction & property",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Construction, property developers and housebuilding firms",
    client: "all",
    keys: [
      "ind:trust_construction:trust_completely:cat",
      "ind:trust_construction:tend_trust:cat",
      "ind:trust_construction:neither:cat",
      "ind:trust_construction:tend_distrust:cat",
      "ind:trust_construction:no_trust:cat",
      "ind:trust_construction:dk:cat",
    ],
    labels: {
      "ind:trust_construction:trust_completely:cat": "Trust completely",
      "ind:trust_construction:tend_trust:cat":       "Tend to trust",
      "ind:trust_construction:neither:cat":          "Neither trust nor distrust",
      "ind:trust_construction:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_construction:no_trust:cat":         "Do not trust at all",
      "ind:trust_construction:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_construction:trust_completely:cat", "ind:trust_construction:tend_trust:cat"],
      neu: "ind:trust_construction:neither:cat",
      neg: ["ind:trust_construction:tend_distrust:cat", "ind:trust_construction:no_trust:cat"],
      dk:  "ind:trust_construction:dk:cat",
    },
    schema: "tracking",
    waves: [3,4,5]
  },

  trust_media: {
    type: "likert",
    label: "Trust: Media & news",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Media and news organisations",
    client: "all",
    keys: [
      "ind:trust_media:trust_completely:cat",
      "ind:trust_media:tend_trust:cat",
      "ind:trust_media:neither:cat",
      "ind:trust_media:tend_distrust:cat",
      "ind:trust_media:no_trust:cat",
      "ind:trust_media:dk:cat",
    ],
    labels: {
      "ind:trust_media:trust_completely:cat": "Trust completely",
      "ind:trust_media:tend_trust:cat":       "Tend to trust",
      "ind:trust_media:neither:cat":          "Neither trust nor distrust",
      "ind:trust_media:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_media:no_trust:cat":         "Do not trust at all",
      "ind:trust_media:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_media:trust_completely:cat", "ind:trust_media:tend_trust:cat"],
      neu: "ind:trust_media:neither:cat",
      neg: ["ind:trust_media:tend_distrust:cat", "ind:trust_media:no_trust:cat"],
      dk:  "ind:trust_media:dk:cat",
    },
    schema: "tracking",
    waves: [3]
  },

  trust_farming: {
    type: "likert",
    label: "Trust: Farming & food production",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Farming and food production companies",
    client: "all",
    keys: [
      "ind:trust_farming:trust_completely:cat",
      "ind:trust_farming:tend_trust:cat",
      "ind:trust_farming:neither:cat",
      "ind:trust_farming:tend_distrust:cat",
      "ind:trust_farming:no_trust:cat",
      "ind:trust_farming:dk:cat",
    ],
    labels: {
      "ind:trust_farming:trust_completely:cat": "Trust completely",
      "ind:trust_farming:tend_trust:cat":       "Tend to trust",
      "ind:trust_farming:neither:cat":          "Neither trust nor distrust",
      "ind:trust_farming:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_farming:no_trust:cat":         "Do not trust at all",
      "ind:trust_farming:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_farming:trust_completely:cat", "ind:trust_farming:tend_trust:cat"],
      neu: "ind:trust_farming:neither:cat",
      neg: ["ind:trust_farming:tend_distrust:cat", "ind:trust_farming:no_trust:cat"],
      dk:  "ind:trust_farming:dk:cat",
    },
    schema: "tracking",
    waves: [3,4,5]
  },

  trust_gambling: {
    type: "likert",
    label: "Trust: Gambling",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Gambling companies and bookmakers",
    client: "all",
    keys: [
      "ind:trust_gambling:trust_completely:cat",
      "ind:trust_gambling:tend_trust:cat",
      "ind:trust_gambling:neither:cat",
      "ind:trust_gambling:tend_distrust:cat",
      "ind:trust_gambling:no_trust:cat",
      "ind:trust_gambling:dk:cat",
    ],
    labels: {
      "ind:trust_gambling:trust_completely:cat": "Trust completely",
      "ind:trust_gambling:tend_trust:cat":       "Tend to trust",
      "ind:trust_gambling:neither:cat":          "Neither trust nor distrust",
      "ind:trust_gambling:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_gambling:no_trust:cat":         "Do not trust at all",
      "ind:trust_gambling:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_gambling:trust_completely:cat", "ind:trust_gambling:tend_trust:cat"],
      neu: "ind:trust_gambling:neither:cat",
      neg: ["ind:trust_gambling:tend_distrust:cat", "ind:trust_gambling:no_trust:cat"],
      dk:  "ind:trust_gambling:dk:cat",
    },
    schema: "tracking",
    waves: [3,4,5]
  },

  trust_manufacturing: {
    type: "likert",
    label: "Trust: Manufacturing",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Manufacturing firms",
    client: "all",
    keys: [
      "ind:trust_manufacturing:trust_completely:cat",
      "ind:trust_manufacturing:tend_trust:cat",
      "ind:trust_manufacturing:neither:cat",
      "ind:trust_manufacturing:tend_distrust:cat",
      "ind:trust_manufacturing:no_trust:cat",
      "ind:trust_manufacturing:dk:cat",
    ],
    labels: {
      "ind:trust_manufacturing:trust_completely:cat": "Trust completely",
      "ind:trust_manufacturing:tend_trust:cat":       "Tend to trust",
      "ind:trust_manufacturing:neither:cat":          "Neither trust nor distrust",
      "ind:trust_manufacturing:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_manufacturing:no_trust:cat":         "Do not trust at all",
      "ind:trust_manufacturing:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_manufacturing:trust_completely:cat", "ind:trust_manufacturing:tend_trust:cat"],
      neu: "ind:trust_manufacturing:neither:cat",
      neg: ["ind:trust_manufacturing:tend_distrust:cat", "ind:trust_manufacturing:no_trust:cat"],
      dk:  "ind:trust_manufacturing:dk:cat",
    },
    schema: "tracking",
    waves: [3]
  },

  // =========================================================================
  // SECTOR TRUST — new wave 4 sectors
  // =========================================================================
  trust_oil: {
    type: "likert",
    label: "Trust: Oil & gas",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Oil and gas companies",
    client: "all",
    keys: [
      "ind:trust_oil:trust_completely:cat",
      "ind:trust_oil:tend_trust:cat",
      "ind:trust_oil:neither:cat",
      "ind:trust_oil:tend_distrust:cat",
      "ind:trust_oil:no_trust:cat",
      "ind:trust_oil:dk:cat",
    ],
    labels: {
      "ind:trust_oil:trust_completely:cat": "Trust completely",
      "ind:trust_oil:tend_trust:cat":       "Tend to trust",
      "ind:trust_oil:neither:cat":          "Neither trust nor distrust",
      "ind:trust_oil:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_oil:no_trust:cat":         "Do not trust at all",
      "ind:trust_oil:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_oil:trust_completely:cat", "ind:trust_oil:tend_trust:cat"],
      neu: "ind:trust_oil:neither:cat",
      neg: ["ind:trust_oil:tend_distrust:cat", "ind:trust_oil:no_trust:cat"],
      dk:  "ind:trust_oil:dk:cat",
    },
    schema: "tracking",
    waves: [4,5]
  },

  trust_online: {
    type: "likert",
    label: "Trust: Online retailers",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Online retailers",
    client: "all",
    keys: [
      "ind:trust_online:trust_completely:cat",
      "ind:trust_online:tend_trust:cat",
      "ind:trust_online:neither:cat",
      "ind:trust_online:tend_distrust:cat",
      "ind:trust_online:no_trust:cat",
      "ind:trust_online:dk:cat",
    ],
    labels: {
      "ind:trust_online:trust_completely:cat": "Trust completely",
      "ind:trust_online:tend_trust:cat":       "Tend to trust",
      "ind:trust_online:neither:cat":          "Neither trust nor distrust",
      "ind:trust_online:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_online:no_trust:cat":         "Do not trust at all",
      "ind:trust_online:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_online:trust_completely:cat", "ind:trust_online:tend_trust:cat"],
      neu: "ind:trust_online:neither:cat",
      neg: ["ind:trust_online:tend_distrust:cat", "ind:trust_online:no_trust:cat"],
      dk:  "ind:trust_online:dk:cat",
    },
    schema: "tracking",
    waves: [4,5]
  },

  trust_propertydev: {
    type: "likert",
    label: "Trust: Property developers",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Property developers and housebuilding firms",
    client: "all",
    keys: [
      "ind:trust_propertydev:trust_completely:cat",
      "ind:trust_propertydev:tend_trust:cat",
      "ind:trust_propertydev:neither:cat",
      "ind:trust_propertydev:tend_distrust:cat",
      "ind:trust_propertydev:no_trust:cat",
      "ind:trust_propertydev:dk:cat",
    ],
    labels: {
      "ind:trust_propertydev:trust_completely:cat": "Trust completely",
      "ind:trust_propertydev:tend_trust:cat":       "Tend to trust",
      "ind:trust_propertydev:neither:cat":          "Neither trust nor distrust",
      "ind:trust_propertydev:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_propertydev:no_trust:cat":         "Do not trust at all",
      "ind:trust_propertydev:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_propertydev:trust_completely:cat", "ind:trust_propertydev:tend_trust:cat"],
      neu: "ind:trust_propertydev:neither:cat",
      neg: ["ind:trust_propertydev:tend_distrust:cat", "ind:trust_propertydev:no_trust:cat"],
      dk:  "ind:trust_propertydev:dk:cat",
    },
    schema: "tracking",
    waves: [4,5]
  },

  trust_hospitality: {
    type: "likert",
    label: "Trust: Hospitality",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Hospitality (e.g. restaurants, hotels)",
    client: "all",
    keys: [
      "ind:trust_hospitality:trust_completely:cat",
      "ind:trust_hospitality:tend_trust:cat",
      "ind:trust_hospitality:neither:cat",
      "ind:trust_hospitality:tend_distrust:cat",
      "ind:trust_hospitality:no_trust:cat",
      "ind:trust_hospitality:dk:cat",
    ],
    labels: {
      "ind:trust_hospitality:trust_completely:cat": "Trust completely",
      "ind:trust_hospitality:tend_trust:cat":       "Tend to trust",
      "ind:trust_hospitality:neither:cat":          "Neither trust nor distrust",
      "ind:trust_hospitality:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_hospitality:no_trust:cat":         "Do not trust at all",
      "ind:trust_hospitality:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_hospitality:trust_completely:cat", "ind:trust_hospitality:tend_trust:cat"],
      neu: "ind:trust_hospitality:neither:cat",
      neg: ["ind:trust_hospitality:tend_distrust:cat", "ind:trust_hospitality:no_trust:cat"],
      dk:  "ind:trust_hospitality:dk:cat",
    },
    schema: "tracking",
    waves: [4,5]
  },

  trust_defence: {
    type: "likert",
    label: "Trust: Defence contractors",
    category: "business",
    hidden: true,
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Defence contractors",
    client: "all",
    keys: [
      "ind:trust_defence:trust_completely:cat",
      "ind:trust_defence:tend_trust:cat",
      "ind:trust_defence:neither:cat",
      "ind:trust_defence:tend_distrust:cat",
      "ind:trust_defence:no_trust:cat",
      "ind:trust_defence:dk:cat",
    ],
    labels: {
      "ind:trust_defence:trust_completely:cat": "Trust completely",
      "ind:trust_defence:tend_trust:cat":       "Tend to trust",
      "ind:trust_defence:neither:cat":          "Neither trust nor distrust",
      "ind:trust_defence:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_defence:no_trust:cat":         "Do not trust at all",
      "ind:trust_defence:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_defence:trust_completely:cat", "ind:trust_defence:tend_trust:cat"],
      neu: "ind:trust_defence:neither:cat",
      neg: ["ind:trust_defence:tend_distrust:cat", "ind:trust_defence:no_trust:cat"],
      dk:  "ind:trust_defence:dk:cat",
    },
    schema: "tracking",
    waves: [4,5]
  },

  // =========================================================================
  // TRUST DRIVERS
  // =========================================================================
  trust_drivers: {
    type: "categorical",
    label: "Trust drivers",
    category: "business",
    fulltext: "Which of the following things should businesses and business leaders prioritise in order to improve your trust in them? Please select up to three.",
    client: "all",
    keys: [
      "ind:trust_drivers:create_jobs:cat",
      "ind:trust_drivers:customer_service:cat",
      "ind:trust_drivers:environmentally_responsible:cat",
      "ind:trust_drivers:invest_tech:cat",
      "ind:trust_drivers:role_models:cat",
      "ind:trust_drivers:apprenticeships_national:cat",
      "ind:trust_drivers:apprenticeships_local:cat",
      "ind:trust_drivers:treat_employees:cat",
      "ind:trust_drivers:social_issues:cat",
      "ind:trust_drivers:local_charities:cat",
      "ind:trust_drivers:national_charities:cat",
      "ind:trust_drivers:shareholders:cat",
      "ind:trust_drivers:other:cat",
      "ind:trust_drivers:none:cat",
    ],
    labels: {
      "ind:trust_drivers:create_jobs:cat":                    "Create jobs",
      "ind:trust_drivers:customer_service:cat":               "Prioritise the customer with competitive pricing and excellent service",
      "ind:trust_drivers:environmentally_responsible:cat":    "Act in an environmentally responsible way",
      "ind:trust_drivers:invest_tech:cat":                    "Invest in technology to improve products and services",
      "ind:trust_drivers:role_models:cat":                    "Be role models in standards of personal behaviour",
      "ind:trust_drivers:apprenticeships_national:cat":       "Invest in training and apprenticeships across the country",
      "ind:trust_drivers:apprenticeships_local:cat":          "Invest in training and apprenticeships in your local area",
      "ind:trust_drivers:treat_employees:cat":                "Treat employees well and fairly",
      "ind:trust_drivers:social_issues:cat":                  "Lead the public conversation on social issues",
      "ind:trust_drivers:local_charities:cat":                "Support local charities and community groups",
      "ind:trust_drivers:national_charities:cat":             "Support national charities",
      "ind:trust_drivers:shareholders:cat":                   "Maximise value for shareholders and investors",
      "ind:trust_drivers:other:cat":                          "Other",
      "ind:trust_drivers:none:cat":                           "None of these",
    },
    colors: {
      "ind:trust_drivers:create_jobs:cat":                    "#1E88E5",
      "ind:trust_drivers:customer_service:cat":               "#D81B60",
      "ind:trust_drivers:environmentally_responsible:cat":    "#2E7D32",
      "ind:trust_drivers:invest_tech:cat":                    "#7B1FA2",
      "ind:trust_drivers:role_models:cat":                    "#F57C00",
      "ind:trust_drivers:apprenticeships_national:cat":       "#00897B",
      "ind:trust_drivers:apprenticeships_local:cat":          "#0097A7",
      "ind:trust_drivers:treat_employees:cat":                "#388E3C",
      "ind:trust_drivers:social_issues:cat":                  "#F06292",
      "ind:trust_drivers:local_charities:cat":                "#F9A825",
      "ind:trust_drivers:national_charities:cat":             "#6D4C41",
      "ind:trust_drivers:shareholders:cat":                   "#37474F",
      "ind:trust_drivers:other:cat":                          "#777777",
      "ind:trust_drivers:none:cat":                           "#BDBDBD",
    },
    schema: "tracking",
    waves: [3,4]
  },

  // =========================================================================
  // LOCAL BUSINESS CHALLENGE
  // =========================================================================
  local_business_challenge: {
    type: "categorical",
    label: "Local Business Challenges",
    category: "business",
    fulltext: "Which of the following do you think is the biggest challenge facing local businesses in your area?",
    client: "all",
    keys: [
      "business:localbusinesschallenge:CostDoingBusiness:cat",
      "business:localbusinesschallenge:AccessFinance:cat",
      "business:localbusinesschallenge:Crime:cat",
      "business:localbusinesschallenge:HighStreet:cat",
      "business:localbusinesschallenge:Online:cat",
      "business:localbusinesschallenge:PlanningRegulation:cat",
      "business:localbusinesschallenge:ShortageWorkers:cat",
      "business:localbusinesschallenge:Tax:cat",
      "business:localbusinesschallenge:Transport:cat",
      "business:localbusinesschallenge:NoNa:cat",
    ],
    labels: {
      "business:localbusinesschallenge:AccessFinance:cat":      "Access to Finance",
      "business:localbusinesschallenge:CostDoingBusiness:cat":  "Cost of Doing Business",
      "business:localbusinesschallenge:Crime:cat":              "Crime",
      "business:localbusinesschallenge:HighStreet:cat":         "State of High Street",
      "business:localbusinesschallenge:Online:cat":             "Online Competition",
      "business:localbusinesschallenge:PlanningRegulation:cat": "Planning & Regulation",
      "business:localbusinesschallenge:ShortageWorkers:cat":    "Worker Shortage",
      "business:localbusinesschallenge:Tax:cat":                "Tax Rates",
      "business:localbusinesschallenge:Transport:cat":          "Transport Links",
      "business:localbusinesschallenge:NoNa:cat":               "Don't Know / None",
    },
    colors: {
      "business:localbusinesschallenge:CostDoingBusiness:cat":  "#D32F2F",
      "business:localbusinesschallenge:AccessFinance:cat":      "#388E3C",
      "business:localbusinesschallenge:Crime:cat":              "#1976D2",
      "business:localbusinesschallenge:HighStreet:cat":         "#F57C00",
      "business:localbusinesschallenge:Online:cat":             "#7B1FA2",
      "business:localbusinesschallenge:PlanningRegulation:cat": "#0097A7",
      "business:localbusinesschallenge:ShortageWorkers:cat":    "#FBC02D",
      "business:localbusinesschallenge:Tax:cat":                "#5D4037",
      "business:localbusinesschallenge:Transport:cat":          "#455A64",
      "business:localbusinesschallenge:NoNa:cat":               "#BDBDBD",
    },
    schema: "single"
  },

  segment: {
    type: "categorical",
    label: "Segment",
    category: "business",
    fulltext: "Attitudinal segment",
    client: ["all", "motability-operations", "stack-data-strategy"],
    keys: [
      "seg_comfortable_traditionalists",
      "seg_progressive_idealists",
      "seg_open_liberals",
      "seg_nostalgic_populists",
      "seg_hard_bargainers",
      "seg_disenchanted_restless",
      "seg_detached_middle"
    ],
    labels: {
      "seg_comfortable_traditionalists": "Comfortable Traditionalists",
      "seg_progressive_idealists": "Progressive Idealists",
      "seg_open_liberals": "Open Liberals",
      "seg_nostalgic_populists": "Nostalgic Populists",
      "seg_hard_bargainers": "Hard Bargainers",
      "seg_disenchanted_restless": "Disenchanted and Restless",
      "seg_detached_middle": "Detached Middle"
    },
    colors: {
      "seg_comfortable_traditionalists": "#1565C0",
      "seg_progressive_idealists": "#2E7D32",
      "seg_open_liberals": "#00838F",
      "seg_nostalgic_populists": "#C62828",
      "seg_hard_bargainers": "#EF6C00",
      "seg_disenchanted_restless": "#6A1B9A",
      "seg_detached_middle": "#757575"
    },
    schema: "tracking",
    waves: [4]
  },
};
